import { useMutation } from '@tanstack/react-query';
import { getMutationFn } from '../../../../../../../src/apiHooks/core/rest/useFetchMutation';

export type DuplicateFoldersAndReportsPayload = {
  sourceFolderIds: string[];
  sourceReportIds: string[];
  destinationFolderId: string;
  reportDescription?: string;
  reportTitle?: string;
};

export interface DuplicateItemsResponse {
  duplicated: {
    folders: DuplicateItem[];
    reports: DuplicateItem[];
    total: number;
  };
  failed: {
    folders: DuplicateError[];
    reports: DuplicateError[];
    total: number;
  };
}

export type DuplicateItem = {
  id: string;
  title: string;
};

export type DuplicateError = {
  id: string;
  reason: {
    code: string;
    message: string;
  };
};

export const useDuplicateFoldersAndReports = () => {
  const mutationKey = ['duplicateFoldersAndReports'];
  const foldersAndReportsMutationFn = getMutationFn<DuplicateItemsResponse, DuplicateFoldersAndReportsPayload>({
    errorType: 'text'
  });

  return useMutation(
    async (foldersAndReportsPayload: DuplicateFoldersAndReportsPayload) =>
      foldersAndReportsMutationFn({
        url: `/api/reporting_service/v4/reports/duplicate`,
        body: foldersAndReportsPayload
      }),
    { mutationKey }
  );
};
